module.exports = __webpack_public_path__ + "img/edge_activites_mode.cd994e32.svg";